/**
 * 首页-改模块
 */
import request from '@/api/axios'
import { apiList as api } from './apiList'

export function getPrepareList(userId, data) {
  const params = { ...data, orderBy: 'desc', pubStatus: 1, queryKey: '' }
  // 习练列表
  return request({
    url: api.indexGai.prepareList + userId,
    method: 'get',
    params,
  })
}

export function getRepeal(pubId) {
  // 撤销
  return request({
    url: api.indexGai.repeal + pubId,
    method: 'delete',
  })
}
export function getPaperPub(paperId, userId) {
  // 习练详情
  return request({
    url: api.indexGai.paperPub + paperId + '/' + userId,
    method: 'get',
  })
}
/**
 * 获取学程列表
 */
export function getCourseList(page) {
  const data = { ...page, sortBy: 'desc', pubStatus: 1, preStatus: 1 }
  // 获取学程列表
  return request({
    url: api.indexGai.getCourseList,
    method: 'post',
    data,
  })
}
export function getCourseDetails(courseId) {
  // 学程发布详情
  return request({
    url: api.indexGai.getCourseDetails + courseId,
    method: 'get',
  })
}
export function getCourseRevoke(courseId, groupId) {
  // 学程撤销发布
  return request({
    url: api.indexGai.getCourseRevoke + courseId + '/' + groupId,
    method: 'get',
  })
}
export function getCourseReviewInfo(id, groupId) {
  // 查询学程批阅信息
  return request({
    url: api.indexGai.markedInfo + id + '/' + groupId,
    method: 'get',
  })
}
